import React from 'react';
import PropTypes from 'prop-types';
import Alert from 'react-s-alert';
import { PsDate } from '../../../../shared/model/PsDate';
import { I18nUtils } from '../../../../../i18n/I18nUtils';
import { PresenceSelectedWorkers } from './PresenceSelectedWorkers';
import { ListPresencesRequest } from '../webservices/list-presence/ListPresencesRequest';
import { ListPresencesTask } from '../webservices/list-presence/ListPresencesTask';
import { PsPresence } from '../PsPresence';
import { AddPresenceRequest } from '../webservices/add-presence/AddPresenceRequest';
import { AddPresenceTask } from '../webservices/add-presence/AddPresenceTask';
import { PresenceAddOutsourcesCard } from './PresenceAddOutsourcesCard';
import { PresenceImportDayCard } from './PresenceImportDayCard';
import './PresenceCard.css';
import './PresenceAddCard.css';

export class PresenceAddCard extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            error: '',
            search: '',
            loading: false,
            presences: [],
            presencesDate: PsDate.fromNow(),
        };
    }

    componentDidMount() {
        this.listPresences();
    }

    render() {
        const { workId } = this.props;
        const {
            loading,
            presences,
            presencesDate,
        } = this.state;

        return (
            <div className="row presence-add-card-container">
                <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                    <PresenceSelectedWorkers
                        workId={workId}
                        loading={loading}
                        presences={presences}
                        importDay={this.importDay}
                        selectDate={this.selectDate}
                        savePresences={this.savePresences}
                        presencesDate={presencesDate}
                        selectPresences={this.selectPresences}
                    />
                </div>
                <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                    <PresenceAddOutsourcesCard
                        presences={presences}
                        selectPresence={this.selectPresence}
                        selectPresences={this.selectPresences}
                    />
                    <PresenceImportDayCard
                        workId={workId}
                        presences={presences}
                        importDay={this.importDay}
                        selectPresences={this.selectPresences}
                    />
                </div>
            </div>
        );
    }

    listPresences = () => {
        const { presencesDate } = this.state;
        const { workId } = this.props;
        const request = new ListPresencesRequest();

        request.setConstructionId(workId);
        request.setDate(presencesDate);
        request.setSkipPagination(true);

        new ListPresencesTask(request)
            .onPreExecution(() => this.setState({ loading: true }))
            .onSuccess(res => {
                const presences = PsPresence.arrayFromBackend(res.data.presences || []);
                this.setState({ presences });
            })
            .onFail(error => Alert.error(error))
            .onPostExecution(() => this.setState({ loading: false }))
            .execute();
    };

    savePresences = () => {
        const { workId } = this.props;
        const { presences, presencesDate } = this.state;

        const request = new AddPresenceRequest(presencesDate, workId);
        request.setPresences(presences.map(presence => presence.workerId()));

        new AddPresenceTask(request)
            .onPreExecution(() => this.setState({ loading: true }))
            .onSuccess(() => Alert.success(I18nUtils.tr('TR_PRESENCIAS_ANADIDAS_CORRECTAMENTE')))
            .onFail(error => Alert.error(error || I18nUtils.tr('TR_ADD_WORKER_PRESENCE_BATCH_ERROR')))
            .onPostExecution(() => this.listPresences())
            .execute();
    };

    selectDate = (date) => {
        const presencesDate = PsDate.fromDDMMYYYY(date);
        this.setState({ presencesDate }, this.listPresences);
    };

    selectPresences = (presences) => {
        this.setState({ presences });
    };

    selectPresence = (presence) => {
        this.setState((prevState) => ( { presences: [...prevState.presences, presence] } ));
    };

    importDay = (presences) => {
        const importedPresences = [];
        presences.forEach(presence => {
            const isSelected = presences.find(p => p.value === presence.workerId());
            if ( !isSelected ) {
                const importedPresence = PsPresence.fromWorker(presence.worker());
                importedPresences.push(importedPresence);
            }
        });

        this.setState((prevState) => ( { presences: [...prevState.presences, ...importedPresences] } ));
    };
}

PresenceAddCard.propTypes = {
    workId: PropTypes.number.isRequired,
};

PresenceAddCard.defaultProps = {};



// WEBPACK FOOTER //
// ./src/app/my-outsources/presence/management/add/PresenceAddCard.jsx